import script from "./BackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=6d7c384e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7c384e"]])

export default __exports__